import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "autoRepeat", "minWidth", "children"];
import styled from 'styled-components';
import { Layout } from './Layout';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultMinWidth = '20rem';
const StyledLayoutGrid = styled(Layout).withConfig({
  displayName: "LayoutGridAuto__StyledLayoutGrid",
  componentId: "sc-1r0jyuu-0"
})(["", " grid-template-columns:repeat(var(--auto-repeat),minmax(var(--min-width),1fr));"], ({
  $autoRepeat,
  $minWidth
}) => `
    --auto-repeat: ${$autoRepeat};
    --min-width: ${$minWidth};
  `);
export const LayoutGridAuto = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      autoRepeat = 'auto-fill',
      minWidth = defaultMinWidth,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledLayoutGrid, Object.assign({}, rest, {
    $autoRepeat: autoRepeat,
    $minWidth: minWidth,
    display: "grid",
    forwardedAs: as,
    ref: ref,
    children: children
  }));
});